


































































































































import Vue from "vue";
import { UAUserAccess } from "@/user-administration/models/UAUserAccess";
import Search from "@/common/components/Search.vue";
import { storeService } from "@/common/services/StoreService";
import UAAddUser from "@/user-administration/components/UAAddUser.vue";
import { accessService } from "@/user-administration/services/UAAccessService";
import { userService } from "@/common/services/UserService";
import { AdminStore } from "@/common/models/AdminStore";
import UAUpdateAccess from "@/user-administration/components/UAUpdateAccess.vue";
import UARemoveAccess from "@/user-administration/components/UARemoveAccess.vue";

export default Vue.extend({
  name: "UAUserList",
  components: {
    UARemoveAccess,
    UAUpdateAccess,
    UAAddUser,
    Search,
  },
  data() {
    return {
      snackbar: false,
      message: "",
      isLoading: true,
      search: "",
      selectedStore: null as AdminStore | null,
      users: [] as UAUserAccess[],
      editAccessModalOpen: false,
      accessLevels: ["STAFF", "MANAGER", "ADMIN"],
      updatingAccess: false,
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: "Email", value: "email" },
        { text: "Access Level", value: "accessLevel" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      userService,
      storeService,
    };
  },
  computed: {
    currentStore(): string {
      return this.storeService.selectedStore;
    },
  },
  watch: {
    currentStore: function (): void {
      this.setSelectedStore();
    },
  },
  async mounted() {
    await this.setSelectedStore();
    if (this.selectedStore) {
      this.users = await this.getUsers(this.selectedStore);
    }
    this.isLoading = false;
  },
  methods: {
    async setSelectedStore(): Promise<void> {
      storeService.getAdminStoreById(this.storeService.selectedStore).then(async (result) => {
        if (result) {
          this.isLoading = true;
          this.selectedStore = result;
          await this.reloadUsers();
        } else {
          this.selectedStore = null;
        }
      });
    },
    async getUsers(store: AdminStore): Promise<UAUserAccess[]> {
      return await accessService.getAccess(store.id);
    },
    async updateAccessLevel(access: UAUserAccess, updatedValue: string): Promise<void> {
      this.updatingAccess = true;
      access.accessLevel = updatedValue;
      await accessService.updateAccess(access);
      this.snackbar = true;
      this.message = this.$t("modules.user-administration.snackbar.saved-user").toString();
      await this.reloadUsers();
      this.updatingAccess = false;
    },
    async deleteAccess(access: UAUserAccess): Promise<void> {
      await accessService.removeAccess(access);
      await this.reloadUsers();
    },
    async savedUser(): Promise<void> {
      this.message = this.$t("modules.user-administration.snackbar.added-user").toString();
      this.snackbar = true;
      await this.reloadUsers();
    },
    async reloadUsers(): Promise<void> {
      if (this.selectedStore) {
        this.users = await accessService.getAccess(this.selectedStore.id);
      }
      this.isLoading = false;
    },
  },
});
